import { useEffect } from 'react';

let activeLocks = 0;
let previousBodyOverflow = '';
let previousHtmlOverflow = '';
let previousBodyPaddingRight = '';

function lockPageScroll() {
  if (typeof document === 'undefined') return;
  if (activeLocks === 0) {
    previousBodyOverflow = document.body.style.overflow;
    previousHtmlOverflow = document.documentElement.style.overflow;
    previousBodyPaddingRight = document.body.style.paddingRight;
    const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';
    if (scrollbarWidth > 0) {
      document.body.style.paddingRight = `${scrollbarWidth}px`;
    }
  }
  activeLocks += 1;
}

function unlockPageScroll() {
  if (typeof document === 'undefined') return;
  activeLocks = Math.max(0, activeLocks - 1);
  if (activeLocks > 0) return;
  document.body.style.overflow = previousBodyOverflow || '';
  document.documentElement.style.overflow = previousHtmlOverflow || '';
  document.body.style.paddingRight = previousBodyPaddingRight || '';
  previousBodyOverflow = '';
  previousHtmlOverflow = '';
  previousBodyPaddingRight = '';
}

/**
 * Locks background page scroll while an Event Log modal is open,
 * without blocking wheel/touch scrolling inside the modal.
 * Uses a shared lock count so close always restores scrolling.
 */
export function useEventLogModalScrollLock(isOpen, overlayRef, containerRef) {
  useEffect(() => {
    if (!isOpen || typeof document === 'undefined') return undefined;

    lockPageScroll();

    const isInsideScrollableModal = (target) => {
      if (!(target instanceof Node)) return false;
      if (containerRef?.current?.contains(target)) return true;
      if (overlayRef?.current && target !== overlayRef.current && overlayRef.current.contains(target)) {
        return true;
      }
      return Boolean(
        target.closest?.(
          '.practices-list-modal-container, .practices-list-modal-body, .patient-details-event-logs-modal, .patient-details-event-logs-modal-body, .dashboard-event-logs-modal, .event-log-section-container'
        )
      );
    };

    const preventBackgroundScroll = (event) => {
      if (isInsideScrollableModal(event.target)) return;
      event.preventDefault();
    };

    document.addEventListener('wheel', preventBackgroundScroll, { passive: false });
    document.addEventListener('touchmove', preventBackgroundScroll, { passive: false });

    return () => {
      document.removeEventListener('wheel', preventBackgroundScroll);
      document.removeEventListener('touchmove', preventBackgroundScroll);
      unlockPageScroll();
    };
  }, [isOpen, overlayRef, containerRef]);
}

export default useEventLogModalScrollLock;
